export default {"src":"/komodo/_next/static/media/instagram.d7f4fa86.svg","height":67,"width":67,"blurWidth":0,"blurHeight":0};